/**
 * Generic Entity Card Component
 * Fallback card for unknown entity types
 */

import React from 'react';
import './EntityCard.css';

interface GenericEntityCardProps {
  data: any;
}

export const GenericEntityCard: React.FC<GenericEntityCardProps> = ({
  data,
}) => {
  if (!data || typeof data !== 'object') {
    return <div className="generic-result">{String(data)}</div>;
  }

  // Try to display object as key-value pairs
  return (
    <div className="entity-card generic-card">
      <div className="entity-card-body">
        {Object.entries(data).map(([key, value]) => (
          <div key={key} className="entity-card-field">
            <span className="field-label">{key}:</span>
            <span className="field-value">
              {typeof value === 'object'
                ? JSON.stringify(value)
                : String(value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
